import { useParams } from 'react-router-dom';
import { Seo } from '../../components/Seo.jsx';
import { AdminTabs } from '../../components/AdminTabs.jsx';
import { Mermaid } from '../../components/Mermaid.jsx';
import { DIAGRAM_SECTIONS } from './diagrams.js';

/** How Affily works, one section per tab, drawn from diagrams.js. */
export default function Diagrams() {
  const { section } = useParams();
  const current = DIAGRAM_SECTIONS.find((s) => s.key === section) ?? DIAGRAM_SECTIONS[0];

  return (
    <div className="mx-auto max-w-6xl space-y-8 px-4 py-10 sm:px-6">
      <Seo title={current.title} noindex />
      <AdminTabs />

      <header className="max-w-3xl">
        <h1 className="text-2xl font-semibold tracking-tight">{current.title}</h1>
        <p className="mt-2 text-sm text-ink-muted">{current.intro}</p>
      </header>

      {current.charts.map((c) => (
        <section key={c.title} className="space-y-3 rounded-lg border border-rule bg-paper-raised p-4 sm:p-5">
          <h2 className="font-semibold tracking-tight">{c.title}</h2>
          <Mermaid chart={c.chart} label={c.title} />
          {c.notes && <p className="max-w-3xl text-sm text-ink-muted">{c.notes}</p>}
        </section>
      ))}
    </div>
  );
}
